// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC8UGR4_AaxvRjF7F7Brc-qeo_2ji_fqsw",
    authDomain: "web-guide-app.firebaseapp.com",
    projectId: "web-guide-app",
    storageBucket: "web-guide-app.firebasestorage.app",
    messagingSenderId: "1072173583084",
    appId: "1:1072173583084:web:69a9c358a536b6c3c3f3c9",
    measurementId: "G-3304BLPC0B"
  };

// Firebase を初期化
const app = initializeApp(firebaseConfig);

// Firestore データベースを初期化
export const db = getFirestore(app);

// 位置情報の送信間隔（秒）- 設定で変更可能
export const LOCATION_UPLOAD_INTERVAL = 30; // 30秒間隔（変更可能）